export const values = [
  {
    id: "01",
    title: "Participation and Collaboration",
    desc: "Communities can be empowered to help themselves and should own the process and results of all efforts. We work in partnership with children, the community, our donors, the government and other service providers to meet our shared goals.",
  },
  {
    id: "02",
    title: "Integrity and Accountability",
    desc: "We act at all times with honesty. We demonstrate and account for all stakeholders the effective and efficient use of resources for the best of the beneficiaries being ethically, socially, and culturally responsible, through regular technical and financial audits, regular reports and organizing field visits.",
  },
  {
    id: "03",
    title: "Wholeness",
    desc: "In working with children, every aspect of their growth & development must be addressed, including their physical and psychological wellbeing.",
  },
  {
    id: "04",
    title: "Respect",
    desc: "Children, like all individuals, are worthy of respect. We listen to their interest, needs and ideas, accept them as valued citizens, give the appropriate answers to their questions and ask their consent in endeavors that concerns them. We also respect communities and colleagues from donors, government and other relevant institutions and individuals to engage with them through open communication.",
  },
  {
    id: "05",
    title: "Equity",
    desc: "We are committed to serve children in need with no regard to religion, sex, and ethnicity, political affiliation of guardians, disability and health status.",
  },
];
